var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#67CCD1"
    },
    d: "M49.838,75.734c-10.955,0-19.919,8.964-19.919,19.918v324.404 h450.161V95.652c0-10.955-8.964-19.918-19.919-19.918H49.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#27A2CC"
    },
    d: "M239.471,291.344c5.087,1.363,10.307,2.044,15.529,2.044 c5.221,0,10.442-0.682,15.528-2.044c43.056-11.536,101.593-61.638,130.488-111.685c19.944-34.545,26.771-70.788,20.304-103.926 H88.678c-6.466,33.137,0.362,69.38,20.307,103.925C137.878,229.706,196.415,279.808,239.471,291.344z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.865,
    y: 384.47,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D2DCFD"
    },
    width: 448.269,
    height: 49.704
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FDCB50"
    },
    d: "M400.17,299.277l-65.106,0.17 c-20.172,12.251-37.239,36.546-37.239,61.745v23.476h139.43v-23.476C437.255,335.995,420.342,311.528,400.17,299.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1D952"
    },
    d: "M175.61,298.562l-65.55,0.719 c-20.172,12.251-37.315,36.712-37.315,61.911v23.476h139.43v-23.476C212.175,335.995,195.782,310.813,175.61,298.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD8F7A"
    },
    d: "M367.54,216.782L367.54,216.782 c21.911,0,39.838,17.926,39.838,39.838v19.918c0,21.911-17.927,39.838-39.838,39.838h0c-21.91,0-39.837-17.927-39.837-39.838 V256.62C327.703,234.708,345.63,216.782,367.54,216.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FDBEB9"
    },
    d: "M142.459,216.782L142.459,216.782 c21.911,0,39.838,17.926,39.838,39.838v19.918c0,21.911-17.927,39.838-39.837,39.838h0c-21.91,0-39.837-17.927-39.837-39.838 V256.62C102.622,234.708,120.549,216.782,142.459,216.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6864F7"
    },
    d: "M29.919,474.105h450.163c10.955,0,19.918-8.963,19.918-19.918 v-29.878H314.756c0,5.478-4.481,9.959-9.959,9.959h-99.593c-5.478,0-9.959-4.481-9.959-9.959H10v29.878 C10,465.142,18.963,474.105,29.919,474.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FD7DA0"
    },
    d: "M349.055,149.659C399.687,61.962,306.578,3.683,255,55.261 c-51.578-51.578-144.686,6.701-94.054,94.398c23.302,40.361,70.3,77.365,94.054,83.73 C278.754,227.024,325.752,190.02,349.055,149.659z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M367.54,216.782L367.54,216.782c21.911,0,39.838,17.926,39.838,39.838v19.918c0,21.911-17.927,39.838-39.838,39.838h0 c-21.91,0-39.837-17.927-39.837-39.838V256.62C327.703,234.708,345.63,216.782,367.54,216.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M142.459,216.782L142.459,216.782c21.911,0,39.838,17.926,39.838,39.838v19.918c0,21.911-17.927,39.838-39.837,39.838h0 c-21.91,0-39.837-17.927-39.837-39.838V256.62C102.622,234.708,120.549,216.782,142.459,216.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M29.919,474.105h450.163c10.955,0,19.918-8.963,19.918-19.918v-29.878H314.756c0,5.478-4.481,9.959-9.959,9.959h-99.593 c-5.478,0-9.959-4.481-9.959-9.959H10v29.878C10,465.142,18.963,474.105,29.919,474.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M480.081,420.056V95.652c0-10.955-8.964-19.918-19.919-19.918h-96.493 M146.331,75.734H49.838 c-10.955,0-19.919,8.964-19.919,19.918v324.404"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 255,
    y1: 233.389,
    x2: 255,
    y2: 384.524
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M175.61,298.562c20.172,12.251,36.565,37.433,36.565,62.63v23.476 M72.745,384.668v-23.476c0-25.198,17.143-49.659,37.315-61.911"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M400.17,299.277c20.172,12.251,37.085,36.718,37.085,61.915v23.476 M297.825,384.668v-23.476 c0-25.198,17.067-49.493,37.239-61.745"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M349.055,149.659C399.687,61.962,306.578,3.683,255,55.261c-51.578-51.578-144.686,6.701-94.054,94.398 c23.302,40.361,70.3,77.365,94.054,83.73C278.754,227.024,325.752,190.02,349.055,149.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M198.662,118.14c14.942-14.942,35.207-23.336,56.338-23.336c21.131,0,41.397,8.394,56.338,23.336"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.831,146.309c7.471-7.471,17.604-11.668,28.169-11.668c10.565,0,20.698,4.197,28.169,11.668"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 255.004,
    y1: 174.479,
    x2: 254.996,
    y2: 174.479
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 29.991,
    y1: 384.47,
    x2: 480.064,
    y2: 384.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.dc8047474a18d818c4e19534b007d03e.svg";
export { ForwardRef as ReactComponent };